<template>
  <div class="common-box border-t0 margin-l6">
    <el-row class="row-one">
      <span class="row-one-title">风险测评</span>
      <Reback class="row-one-fr" @click.native="reback"></Reback>
      <span class="row-one-fr" @click="$router.push({name:'riskAssessmentDescription', params:{pathName:'reevaluation'}})">点击查看个人风险测评说明</span>
    </el-row>
    <div class="question">
      <div class="question-con" v-for="(item1,i1) in questionArr" :key="i1 + 'one'">
        <p v-if="item1.error" class="rColor">*请选择您的答案</p>
        <p class="question-tit">{{i1+1+'、' + item1.subjectName}}</p>
        <el-radio-group class="radio-single-two  margin-l20" v-model="item1.subjectKey" @change="change">
          <el-radio v-for="(item2,i2) in item1.subjectValue" :key="i2 + 'two'" :label="item2">{{item2.split('&')[0]}}</el-radio>
        </el-radio-group>
      </div>
      <el-button type="normal" style="margin:50px 0 0 360px;" @click="submit">确定</el-button>
    </div>
  </div>
</template>

<script>
const Base64 = require("js-base64").Base64;
import Vue from 'vue'
export default {
  name: "reevaluation",
  data () {
    return {
      radioOne: 0,
      questionArr: [],
      paperid: '',
    }
  },
  mounted () {
    this.getRiskQuestion()
  },
  methods: {
    reback () {
      this.$emit("func", true)
    },
    getRiskQuestion () {
      this.$http.post(this.$apiPath.getQuestion, {
        sessionId: this.$commonJs.getCookie('sessionid'),
        answer: "",
        papercode: "",
        pointList: "",
        iscontinue: "",
        invtp: "1"
      }).then(res => {
        if (res.status !== 200 && res.data.code !== '200') return
        const result = res.data.data.question
        if (result.length > 0) {
          let questionArray = new Array()// 问题数组
          var code = result[0].questioncode// 第几题
          this.paperid = result[0].papercode
          var obj = { subjectName: result[0].questionname, subjectKey: '', subjectValue: [] }
          for (var i = 0; i < result.length; i++) {
            var item = result[i]
            if (item.questioncode != code) {
              questionArray.push(obj)
              obj = { subjectName: item.questionname, subjectKey: '', subjectValue: [] }
              code = item.questioncode
            }
            // obj.subjectKey.push(item.result + item.resultpoint)
            obj.subjectValue.push(item.result + '.' + item.resultcontent + '&' + item.resultpoint)
            //console.log(item);

          }
          questionArray.push(obj)
          this.questionArr = questionArray
          //   console.log(questionArray);
        }
      }).catch(err => { })
    },
    change (val) {
      this.questionArr.forEach((item, i) => {
        item.subjectValue.forEach(item2 => {
          if (item2 == val) {
            item.error = false
            Vue.set(this.questionArr, i, item)
          }

        })
      })
    },
    submit () {
      let temp = ''// A|D|C|B
      let pointStr = ''// 5|8|8|5|
      this.questionArr.forEach((item, i) => {
        if (item.subjectKey == '') {
          item.error = true
          Vue.set(this.questionArr, i, item)
          this.$message.error('您尚有测评试题未选择！')
        } else {
          temp += item.subjectKey.split('.')[0] + "|"
          pointStr += Number(item.subjectKey.split('&')[1]) + "|"
        }
      })
      if (this.findIndexByKeyValue(this.questionArr, 'error', true) == -1) {
        //   年龄信息
        var idCard = Number(Base64.decode(this.$commonJs.getCookie('u_id')).substr(6, 4))
        var currentYear = new Date().getFullYear()
        var age = currentYear - idCard
        //   if (idCard == "123456") {// 当身份证是123456时，是游客，年龄默认成18
        //     age = 18;
        //   }
        // console.log(age)
        if (age >= 18 && age <= 30) {
          temp += "A"
          pointStr += "2"
        } else if (age >= 31 && age <= 40) {
          temp += "B"
          pointStr += "2"
        } else if (age >= 41 && age <= 50) {
          temp += "C"
          pointStr += "2"
        } else if (age >= 51 && age <= 80) {
          temp += "D"
          pointStr += "2"
        } else if (age >= 81) {
          temp += "F"
          pointStr += "0"
        } else if (age <= 17) {
          temp += "E"
          pointStr += "0"
        }
        // console.log(temp, pointStr);
        this.$http.post(this.$apiPath.updateAccountRiskLevel, {
          sessionId: this.$commonJs.getCookie('sessionid'),
          answer: temp,// A|D|C|B
          papercode: this.paperid,// 001
          pointList: pointStr,// 5|8|8|5|
          iscontinue: "1",//1：风险测试；0：结果延用
          invtp: "1"
        }).then(res => {
          if (res.status !== 200 && res.data.code !== '200') return
          const riskInfo = res.data.data.riskInfo
          if (riskInfo) {
            this.$commonJs.setCookie('u_risk', riskInfo.risklevel, 7)
            this.$router.push({ name: 'riskResult', params: { message: res.data.data } })
          }
        }).catch(err => { })
      }

    },
    findIndexByKeyValue (arr, key, valuetosearch) {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i][key] == valuetosearch) {
          return i;
        }
      }
      return -1;
    }

  }
}
</script>

<style lang="less" scoped>
.el-radio {
  display: block;
  height: 30px;
  line-height: 30px;
}
.question {
  padding: 60px;
  &-tit {
    // height: 30px;
    line-height: 30px;
    margin-bottom: 10px;
  }
  &-con {
    margin-bottom: 30px;
  }
}
</style>
